(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-widget-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const btn = event.target.closest('[data-widget-type]');
    if (!btn) return;

    if (btn.dataset.widgetType === 'accessibility') {
      window.openAccessibility?.();
    } else if (btn.dataset.widgetType === 'chat') {
      window.openTalkdeskChat?.();
    } else if (btn.dataset.widgetType === 'ucmp') {
      window.__ucCmp.showSecondLayer();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
